import { NoteState } from './types';

export const state = (): NoteState => initialState();

export const initialState = (): NoteState => ({
  notes: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['createdDate'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['name', 'text'],
    },
  },
});
